import { render, staticRenderFns } from "./set-free.vue?vue&type=template&id=29cac3c0&scoped=true"
import script from "./set-free.vue?vue&type=script&lang=js"
export * from "./set-free.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cac3c0",
  null
  
)

export default component.exports